module.exports = __webpack_public_path__ + "static/527cce4f9dcb4694464293d5f5b9772356bbca748b5d11c9f5d03c8ec4b876d1-c623ff28365bec819c1b226ec42a81d0.jpeg";